module.exports = __webpack_public_path__ + "static/img/5.ac16fc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/5.png
// module id = VZzD
// module chunks = 0